import { forwardRef } from 'react';
import MuiBox from '@mui/material/Box';
import type { BoxProps } from '@mui/material/Box';

const ForwardedBox = forwardRef<HTMLDivElement, BoxProps>(function Box(
  { children, ...props },
  ref,
) {
  return (
    <MuiBox ref={ref} {...props}>
      {children}
    </MuiBox>
  );
});

export const Box = ForwardedBox as typeof MuiBox;
export type { BoxProps };
